import type { SxProps, Theme } from '@mui/material';

export const handbookContentSx: SxProps<Theme> = theme => {
  const quoteBorder = theme.palette.border?.medium ?? theme.palette.divider;

  return {
    width: '100%',
    '& h1, & h2, & h3, & h4, & h5': {
      color: 'brand',
      marginTop: 0,
      marginBottom: '25px',
    },
    '& p + h1, & p + h2, & p + h3, & p + h4, & p + h5': {
      marginTop: '42px',
    },
    '& p + ul': {
      marginTop: '-7px',
    },
    '& ul p': {
      marginBottom: 0,
    },
    '& ul p + ul': {
      marginTop: '8px',
    },
    '& ul li': {
      marginBottom: '8px',
    },
    '& ul + h1, & ul + h2, & ul + h3, & ul + h4, & ul + h5': {
      marginTop: '46px',
    },
    '& b, & strong': {
      fontWeight: 600,
    },
    '& code': {
      padding: '2px 4px',
      color: `${theme.palette.text.primary} !important`,
      backgroundColor: 'background.default',
      borderRadius: '4px',
    },
    '& .table-wrapper': {
      marginBottom: '16px',
      '@media (max-width: 1499px)': {
        overflowX: 'scroll',
        overflowY: 'visible',
      },
    },
    '& table': {
      marginTop: '12px',
      color: 'text.primary',
      backgroundColor: 'background.paper',
      marginBottom: '30px',
      width: '100%',
      '@media (max-width: 1499px)': {
        minWidth: '1480px',
      },
    },
    '& table thead th': {
      fontWeight: 500,
      display: 'table-cell',
      verticalAlign: 'inherit',
      borderBottom: '1px solid',
      borderColor: 'divider',
      textAlign: 'left',
      padding: '12px',
      color: 'brand',
      fontSize: '12px',
      lineHeight: 1.5,
    },
    '& table td': {
      fontWeight: 400,
      display: 'table-cell',
      verticalAlign: 'inherit',
      borderBottom: '1px solid',
      borderColor: 'divider',
      textAlign: 'left',
      color: 'text.primary',
      fontSize: '14px',
      lineHeight: 1.6,
      padding: '12px',
    },
    '& table tbody tr:hover': {
      backgroundColor: 'common.tableRowHover',
    },
    '& img': {
      maxWidth: '100%',
    },
    '& > :last-child': {
      marginBottom: 0,
    },
    '& p': {
      color: 'text.primary',
      margin: '0 0 16px',
    },
    '& p > code': {
      fontWeight: 'inherit',
    },
    '& blockquote, & .blockquote': {
      margin: '22px 31px 35px 23px',
      border: '2px solid',
      borderColor: 'border.medium',
      padding: '22px 30px 24px',
      boxShadow: `11px 11px 0 0 ${quoteBorder}`,
    },
    '& blockquote br, & .blockquote br': {
      content: "''",
      marginBottom: '16px',
      display: 'block',
    },
    '& blockquote p:last-child, & .blockquote p:last-child': {
      margin: 0,
    },
    '& blockquote + h1, & blockquote + h2, & blockquote + h3, & blockquote + h4, & blockquote + h5, & .blockquote + h1, & .blockquote + h2, & .blockquote + h3, & .blockquote + h4, & .blockquote + h5':
      {
        marginTop: '60px',
      },
    '& hr': {
      margin: '25px 0',
    },
    '& pre': {
      marginBottom: '16px',
      fontSize: '13px',
      lineHeight: '1.6em',
      overflowX: 'auto',
      borderRadius: '2px',
    },
    '& ul, & ol': {
      padding: 0,
      margin: '0 0 16px',
    },
    '& ul ul, & ul ol, & ol ul, & ol ol': {
      marginBottom: 0,
    },
    '& > ul': {
      listStyleType: 'disc',
    },
    '& > ul ul': {
      listStyleType: 'circle',
    },
    '& > ul ul ul': {
      listStyleType: 'square',
    },
    '& li': {
      marginLeft: '25px',
      paddingLeft: '3px',
    },
    '& .big': {
      fontSize: 'larger',
    },
    '& .small': {
      fontSize: 'smaller',
    },
    '& .underline': {
      textDecoration: 'underline',
    },
    '& .overline': {
      textDecoration: 'overline',
    },
    '& .line-through': {
      textDecoration: 'line-through',
    },
  };
};
